const binding = { modules: {}, dataActions: {} };

    (binding.modules['eshop-faq'] = {
        c: () => require('partner/modules/eshop-faq/eshop-faq.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eshop-faq',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eshop-faq'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eshop-faq|eshop-faq'] = {
                c: () => require('partner/modules/eshop-faq/eshop-faq.view.tsx'),
                cn: '__local__-__local__-eshop-faq'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };